export default {
  SET_MODULE_SPACIAL_MATH(state, payload) {
    state.spacialMath = payload;
  },
  SET_MODULE_CLUSTERING(state, payload) {
    state.clustering = payload;
  },
  SET_MODULE_DIRECTIONS(state, payload) {
    state.directions = payload;
  },
  SET_MAPS_API(state, payload) {
    state.mapsAPI = payload;
  },
};
